import { message } from 'antd';
import { getVerifyCode, checkVerifyCode, updatePasswordPc, getPasswordConfig,getCodeImg,passwordStatus } from '../services/password';


export default {
  namespace: 'resetPassword',
  state: {
    resetVisible: false,
    initPwd: '',
    forceUpdatePwd: false,
    verifyPwdStrength: false,
    btnDisabled: false,
    btnTitle: '',
    codeImg: '',
    flag: '',
    passwordLength:8,
    passwordCaseFlag:'否',
    passwordMetacharacters:'',
    passwordStrongFlag:'否'
  },
  effects: {
    * sendCode({ payload }, { call, put }) {
      const { account, captcha, flag } = payload;
      const username = encodeURIComponent(encodeURIComponent(account));
      const imgCode = encodeURIComponent(encodeURIComponent(captcha));
      const res = yield call(getVerifyCode, payload:{flag:flag, account:username, captcha:imgCode});
      if (res && res.code === 200) {
        message.success(res.message);
        yield put({type: 'updateButtonDisabled', payload: {btnDisabled: false}});
      } else if (res.code == 417) {
          message.warn(res.message);
          yield put({ type: 'getCodeImage', payload: {} });
      } else {
        message.warn(res.message);
      }
    },
    * savePassword({ payload }, { call, put }) {
      const { account, verifyCode, confirmPassword, newPassword } = payload;
      const params = {
        account,
        verifyCode,
        newPassword: app.rsaString(newPassword),
        confirmPassword: app.rsaString(confirmPassword),
      };
      const response = yield call(updatePasswordPc, params);
      if (response && response.code === 200) {
        message.success(response.message);
        yield put({ type: 'updateReset', payload: { resetVisible: false } });
        yield put({ type: 'updateButtonDisabled', payload: { btnDisabled: false } });

      } else {
        message.warn(response.message);
      }
    },
    * getSysPasswordConfig({ payload }, { call, put }) {
      const res = yield call(getPasswordConfig);
      if (res && res.code === 200) {
        if (res.result && res.result.forceUpdatePwd) {
          yield put({ type: 'updateForceUpdatePwd',
            payload: { initPwd: res.result.initPwd,
              forceUpdatePwd: res.result.forceUpdatePwd } });
        }
        if (res.result && res.result.verifyPwdStrength) {
          yield put({ type: 'updateVerifyPwdStrength', payload: { verifyPwdStrength: res.result.verifyPwdStrength } });
        }
        const pswChangeWay = res.result.pswChangeWay;
        if (res.result && pswChangeWay) {
          let btnTitle = '';
          if (pswChangeWay.length == 2) {
            btnTitle = '发送验证码到手机及邮箱';
          } else {
            if (pswChangeWay[0] == 'sms' || pswChangeWay[0] == 'smsAli') {
              btnTitle = '发送验证码到手机';
            }
            if (pswChangeWay[0] == 'mail') {
              btnTitle = '发送验证码到邮箱';
            }
          }
          yield put({ type: 'updateBtnTitle', payload: { btnTitle } });
          yield put({ type: 'getCodeImage', payload: {} });
          yield put({ type: 'getPasswordStatus', payload: {} });
          yield put({ type: 'updateReset', payload: { resetVisible: true } });
        } else {
          message.warn('请联系系统管理员配置验证码发送方式');
        }
      } else {
        message.warn(res.result.message);
      }
    },
    * getCodeImage({ }, { call, put }) {
      const response = yield call(getCodeImg);
      if (response.code == 200) {
        yield put({ type: 'updateCodeImage', payload: { codeImage: response.img } });
        yield put({ type: 'updateFlag', payload: { flag: response.flag } });
      }
    },
    * getPasswordStatus({payload}, {call, put}){
      const response = yield  call(passwordStatus);
      if(response.code===200 ){
        let flag = false;
        if(response.data){
          for(let x in response.data){
            if(x == '0126'){
              yield put({type:'update',payload:{passwordStrongFlag:response.data[x]}});
              if(response.data[x] =='是'){
                flag=true;
              }
            }
          }
          for(let m in response.data){
            if( m == '01903' && flag){
              yield put({type:'update',payload:{passwordLength:response.data[m]}});
            }else if( m == '01902' && flag){
              yield put({type:'update',payload:{passwordMetacharacters:response.data[m]}});
            }else if( m == '01901' && flag){
              yield put({type:'update',payload:{passwordCaseFlag:response.data[m]}});
            }
          }}
      }
    },
  },
  reducers: {
    updateReset(state, { payload }) {
      return { ...state, resetVisible: payload.resetVisible };
    },
    updateForceUpdatePwd(state, { payload }) {
      return { ...state,
        initPwd: payload.initPwd,
        forceUpdatePwd: payload.forceUpdatePwd };
    },
    updateVerifyPwdStrength(state, { payload }) {
      return { ...state,
        verifyPwdStrength: payload.verifyPwdStrength };
    },
    updateBtnTitle(state, { payload }) {
      return { ...state,
        btnTitle: payload.btnTitle };
    },
    updateButtonDisabled(state, { payload }) {
      return { ...state, btnDisabled: payload.btnDisabled };
    },
    updateCodeImage(state, { payload }) {
      return { ...state, codeImage: payload.codeImage };
    },
    updateFlag(state, { payload }) {
      return { ...state, flag: payload.flag };
    },
    update(state,{payload}){
      return{
        ...state,
        ...payload
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/models/resetPasssword.js